/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react"
import { styled, Typography } from "@mui/material"
import { Progress } from 'antd';

// Some styled components are shared between the Create and Update restaurant pages, and are located in src/pages/restaurant/shared/styles.jsx
export { SubSectionTitle, SectionDescription, StyledSubSection, ListItem } from "../shared/styles"

export const CreateRestaurantContainer = styled('div')({
  overflowY: 'scroll',
  overflowX: 'hidden',
  height: '100%',
})

export const NavigationContainer = styled('div')({
  minHeight: '250px',
  backgroundColor: '#EEF1FC',
  width: '100%',
  display: 'flex'
})

export const CircularFormProgress = styled('div')({
  height: "226px",
  minWidth: '192px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '25px'
})

export const StyledProgressTypography = styled(Typography)({
  fontSize: '14px',
  fontWeight: '400',
  color: '#6F737B',
  lineHeight: '17.5px',
  letterSpacing: '-0.2px',
})

export const StyledCreateTitle = styled(Typography)({
  fontWeight: '600',
  fontSize: '20px',
  lineHeight: "30px", 
  letterSpacing: '0.35%',
})

export const NavigationDescriptionContainer = styled('div')({
  width: '100%', 
  padding: "30px 10px 10px 20px",
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  borderWidth: '2px',
  borderStyle: 'none none none solid',
  borderColor: '#e0e0e0',
})

export const StyledCard = styled('div')({
  '&:hover': {
    cursor: 'pointer'
  },
  height: '150px', 
  width: '90%',
  maxWidth: '90%',
  boxShadow: '0px 4px 15px 0px #0000001A', 
  backgroundColor: '#ffffff',
  borderRadius: '6px',
  padding: '2px 5px 3px 15px',
})

export const NavigationTitleContainer = styled('div')({
  display: 'flex', 
  gap: '10px', 
  justifyContent: 'start', 
  marginTop: '20px',
  alignItems: 'center'
})

export const StyledNavigationTitle = styled(Typography)({
  fontWeight: '600',
  fontSize: '16px',
  lineHeight: '21px',
  letterSpacing: '-1.4%',
  color: '#1976D2'
})

export const NavigationDescription = styled(Typography)({
  marginTop: '13px',
  fontSize: '16px',
  lineHeight: '21px',
  letterSpacing: '-1.4%',
  fontWeight: '400',
})

export const StyledSectionTitle = styled(Typography)({
  fontWeight: '600',
  color: 'black',
  fontSize: '24px',
})


export const ColorContainer = styled('div')(({ color }) => ({
  height: '30px',
  width: '30px',
  borderRadius: '8px',
  backgroundColor: color ? color : 'transparent'
}))

export const StyledImage = styled('img')({
  height: '275px',
  width: '100%',
  maxWidth: '100%',
  borderRadius: '8px',
})

export const StyledDayTitle = styled(Typography)({
  fontWeight: '600',
  color: 'black',
  fontSize: '16px',
})

export const BusinessDayContainer = styled('div')({
  display: 'flex',
  gap: '17%'
})

export const StyledBusinessDayText = styled(Typography)({
  fontWeight: '400',
  color: 'black',
  fontSize: '16px',
})

export const StyledImageContainer = styled('div')({
  height: '275px',
  width: '100%',
  maxWidth: '100%',
  borderRadius: '8px',
})

export const BannerImageContainer = styled('div')({
  width: '215px',
  height: '146px',
})

export const BannerImg = styled('img')({
  objectFit: "cover",
  width: '100%',
  height: '100%',
  border: '0.25px solid transparent',
  borderRadius: '8px',
})

export const BannerImage = ({ url }) => {
  return (
    <BannerImageContainer>
      <BannerImg
        src={url || "https://placehold.co/256x256?text=No+banner+uploaded"}
        alt="Banner image"
      />
    </BannerImageContainer>
  )
}

export const StyledProgress = styled(Progress)({
  '.ant-progress-text': {
    fontFamily: 'Inter, sans-serif',
  }
})
